module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/lion-btn-audio-portuguesse.da94f04b.png";